import { Box } from '@mui/material'
import { ReactElement, useCallback } from 'react'
import theme from '../../../theme/theme'

export interface ISingleUnitBox {
    isSelected: boolean
    unit: string
    onChangeUnits: (unit: string) => void
}
const SingleUnitBox = (props: ISingleUnitBox): ReactElement => {
    const { isSelected, unit, onChangeUnits } = props

    const handleClick = useCallback(() => {
        if (!isSelected) {
            onChangeUnits(unit)
        }
    }, [isSelected, onChangeUnits, unit])

    return (
        <Box
            id={unit}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '5px 10px',
                minWidth: '35px',
                height: '30px',
                borderRadius: '3px',
                border: `${
                    isSelected
                        ? `2px solid ${theme.palette.primary.main}`
                        : '1px solid #00000030'
                }`,
                cursor: 'pointer',
            }}
            onClick={handleClick}
        >
            {unit || ''}
        </Box>
    )
}

export default SingleUnitBox
